import { Component } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import { Router } from '@angular/router';
import { CustomerService } from '../../../core/services/customer.service';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../../core/dto/pagination';
import { TransferReservationService } from '../../../core/services/transfer-reservation.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../../../modules/auth/services/auth.service';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';

@Component({
  selector: 'app-view-booking',
  templateUrl: './view-booking.component.html',
  styleUrls: ['./view-booking.component.scss'],
})
export class ViewBookingComponent {
  selectedReason = '';
  breadcrumbs: any[] = [];
  searchText: any;
  statusFilter = null;
  dateFilter: any;
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  bookingData: any[] = [];
  isVisibleFuelAndMileageUpdate = false;
  changingStatus: any;
  selectedReservation: any;
  isLoading = false;
  fuelLevel = 0;
  mileage = 0;
  cancelReason: any = null;
  index = 0;

  openMultiplePagingBoardPopup = false;

  skeletonTableColumns: any[] = [
    'SR Tour ID',
    'Booking Category',
    'Status',
    'Agent',
    'Booking Ref No.',
    'Customer Name',
    'No. Of Pass',
    'Tour Date and Time',
    'Flight Number',
    'Pick Location',
    'Drop Location',
    'Vehicle Reg No.',
    'Driver Name',
    'Created Date',
    'Action',
  ];
  cancelReasonOptions: any[] = [
    'No Show',
    'No International License',
    'No Local License',
    'Vehicle Non Availability',
  ];
  loading = false;

  // formatterPercentFuel = (value: number): string => `${value} %`;
  // parserPercentFuel = (value: string): string => value.replace(' %', '');
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');

  constructor(
    private router: Router,
    private transferService: TransferReservationService,
    private messages: NzMessageService,
    private authService: AuthService,
    private message: NzMessageService,
  ) {}

  ngOnInit() {
    this.setBreadcrumbs();
    this.getPagedBookings();
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedBookings();
  }

  getPagedBookings(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchValue: this.searchText,
        status: this.statusFilter,
        dateFilter: this.dateFilter,
      },
    });
    this.transferService
      .getTransferReservationsPaged(payload)
      .then((res: any) => {
        this.loading = false;
        this.bookingData = res.data;
        this.pageSize.length = res.totalItems;
      });
  }

  onChangeDateFilter(result: Date[]): void {
    this.getPagedBookings();
  }

  search(): void {
    this.getPagedBookings();
  }

  resetSearch(): void {
    this.searchText = null;
    this.dateFilter = null;
    this.statusFilter = null;
    this.getPagedBookings();
  }

  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: `Transfer Bookings`,
      },
    ];
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedBookings();
  }

  navigateNewBooking(): void {
    this.router.navigate([`admin/booking-transfer/add-edit`]);
  }

  navigateToSingle(data: any): void {
    this.router.navigate([`admin/booking-transfer/${data}`]);
  }

  deleteBooking(data: any): void {
    // this.customerService.deleteCustomer(data).then(() => {
    //   this.ngOnInit();
    // });
  }

  editNavigate(data: any): void {
    this.router.navigate([`admin/booking-transfer/add-edit/${data}`]);
  }

  handleOkSelectStatus(status: string, data: any, marker: any): void {
    this.selectedReason = marker;
    this.changingStatus = status;
    this.selectedReservation = data;
    const currentDate = new Date();
    if (
      status === 'COMPLETED' &&
      ((marker === 'both' &&
        currentDate <
          new Date(
            data.tourDetails.departureTourDetails.departureDateAndTime,
          )) ||
        (marker === 'single' &&
          data.bookingDetails.bookingCategory === 'Departure' &&
          currentDate <
            new Date(
              data.tourDetails.departureTourDetails.departureDateAndTime,
            )) ||
        (marker === 'single' &&
          data.bookingDetails.bookingCategory !== 'Departure' &&
          currentDate < new Date(data.tourDetails.arrivalDateAndTime)))
    ) {
      this.message.create(
        'warning',
        ` You can not Complete tour before the tour start and time`,
      );
      return;
    }
    if (status === 'ON_TRANSFER' || status === 'COMPLETED') {
      if (
        (marker === 'both' &&
          data?.departureDetails?.driverCategory !== 'OUTSOURCE_DRIVER') ||
        (marker === 'single' &&
          data.bookingDetails.bookingCategory === 'Departure' &&
          data?.departureDetails?.driverCategory !== 'OUTSOURCE_DRIVER') ||
        (marker === 'single' &&
          data.bookingDetails.bookingCategory !== 'Departure' &&
          data?.arrivalDetails?.driverCategory !== 'OUTSOURCE_DRIVER')
      ) {
        if (marker === 'both') {
          this.fuelLevel = data?.departureDetails?.allocatedVehicle
            ?.currentFuelLevel
            ? data?.departureDetails?.allocatedVehicle?.currentFuelLevel
            : 0;
          this.mileage = data?.departureDetails?.allocatedVehicle
            ?.currentMileage
            ? data?.departureDetails?.allocatedVehicle?.currentMileage
            : 0;
        } else if (marker === 'single') {
          if (data.bookingDetails.bookingCategory === 'Departure') {
            this.fuelLevel = data?.departureDetails?.allocatedVehicle
              ?.currentFuelLevel
              ? data?.departureDetails?.allocatedVehicle?.currentFuelLevel
              : 0;
            this.mileage = data?.departureDetails?.allocatedVehicle
              ?.currentMileage
              ? data?.departureDetails?.allocatedVehicle?.currentMileage
              : 0;
          } else {
            this.fuelLevel = data?.arrivalDetails?.allocatedVehicle
              ?.currentFuelLevel
              ? data?.arrivalDetails?.allocatedVehicle?.currentFuelLevel
              : 0;
            this.mileage = data?.arrivalDetails?.allocatedVehicle
              ?.currentMileage
              ? data?.arrivalDetails?.allocatedVehicle?.currentMileage
              : 0;
          }
        }
        this.isVisibleFuelAndMileageUpdate = true;
      } else {
        this.outsourceVehicleStatusUpdate();
      }
    } else if (status === 'CANCELLED') {
      this.isVisibleFuelAndMileageUpdate = true;
    } else {
      let statusCategory;
      if (
        marker === 'both' ||
        data.bookingDetails.bookingCategory === 'Departure'
      ) {
        statusCategory = {
          departureDetails: {
            status: 'RESERVATION',
          },
          updateType: 'departure_status_change',
        };
      } else {
        statusCategory = {
          arrivalDetails: {
            status: 'RESERVATION',
          },
          updateType: 'arrival_status_change',
        };
      }
      this.transferService
        .updateBooking({
          _id: this.selectedReservation._id,
          ...statusCategory,
        })
        .then(
          () => {
            this.isLoading = false;
            this.messages.create(
              'success',
              'Status Changed to Transfer Booking',
            );
            this.getPagedBookings();
            this.changingStatus = 0;
            this.selectedReservation = 0;
          },
          (e: any) => {
            this.messages.create('error', 'Error');
          },
        );
    }
  }

  handleCancelSelectStatus(): void {
    this.changingStatus = null;
    this.isVisibleFuelAndMileageUpdate = false;
  }

  handleOkCancelledStatus(): void {
    this.isLoading = true;
    let remarks: any[] = this.selectedReservation?.remarks;
    if (remarks?.length > 0) {
      remarks?.push({
        action: 'Cancelled',
        remark: this.cancelReason,
        createdBy: this.authService.getLoggedInUser().userId,
      });
    } else {
      remarks = [
        {
          action: 'Cancelled',
          remark: this.cancelReason,
          createdBy: this.authService.getLoggedInUser().userId,
        },
      ];
    }
    let payload = {};
    if (
      this.selectedReason === 'both' ||
      this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
    ) {
      payload = {
        _id: this.selectedReservation._id,
        departureDetails: {
          status: 'CANCELLED',
        },
        remarks,
        updateType: 'departure_status_change',
      };
    } else if (
      this.selectedReservation.bookingDetails.bookingCategory === 'Arrival'
    ) {
      payload = {
        _id: this.selectedReservation._id,
        arrivalDetails: {
          status: 'CANCELLED',
        },
        remarks,
        updateType: 'arrival_status_change',
      };
    }

    this.transferService.updateBooking(payload).then(
      (res: any) => {
        this.isLoading = false;
        this.isVisibleFuelAndMileageUpdate = false;
        this.messages.create('success', 'Status Changed to Cancelled');
        this.getPagedBookings();
        this.changingStatus = null;
        this.selectedReservation = null;
      },
      (e: any) => {
        this.messages.create('error', 'Error');
      },
    );
  }

  handleCancelUpdateFuelAndMileage(): void {
    this.isVisibleFuelAndMileageUpdate = false;
    this.fuelLevel = 0;
    this.mileage = 0;
    this.selectedReservation = null;
    this.changingStatus = null;
  }
  outsourceVehicleStatusUpdate = () => {
    let details = {
      status: '',
    };
    if (
      this.selectedReason === 'both' ||
      this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
    ) {
      details = this.selectedReservation?.departureDetails;
    } else if (
      this.selectedReservation.bookingDetails.bookingCategory === 'Arrival'
    ) {
      details = this.selectedReservation?.arrivalDetails;
    }

    details.status = this.changingStatus;
    let payload = {};
    if (
      this.selectedReason === 'both' ||
      this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
    ) {
      payload = {
        departureDetails: details,
        _id: this.selectedReservation._id,
        updateType: 'departure_status_change',
      };
    } else {
      payload = {
        arrivalDetails: details,
        _id: this.selectedReservation._id,
        updateType: 'arrival_status_change',
      };
    }
    this.transferService.updateBooking(payload).then(
      () => {
        this.messages.create(
          'success',
          `Status Changed to ${this.changingStatus}`,
        );
        this.getPagedBookings();
        this.selectedReason = '';
        this.changingStatus = null;
        this.selectedReservation = null;
      },
      () => {
        this.messages.create('error', 'Error');
      },
    );
  };

  handleOkUpdateFuelAndMileage(): void {
    this.isLoading = true;
    let details = {
      startFuel: 0,
      endFuel: 0,
      startMileage: 0,
      endMileage: 0,
      status: '',
    };
    if (
      this.selectedReason === 'both' ||
      this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
    ) {
      details = this.selectedReservation?.departureDetails;
    } else if (
      this.selectedReservation.bookingDetails.bookingCategory === 'Arrival'
    ) {
      details = this.selectedReservation?.arrivalDetails;
    }

    if (this.changingStatus === 'ON_TRANSFER') {
      details.startFuel = this.fuelLevel;
      details.startMileage = this.mileage;
      details.status = 'ON_TRANSFER';
      let payload = {};
      if (
        this.selectedReason === 'both' ||
        this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
      ) {
        payload = {
          departureDetails: details,
          _id: this.selectedReservation._id,
          updateType: 'departure_status_change',
        };
      } else {
        payload = {
          arrivalDetails: details,
          _id: this.selectedReservation._id,
          updateType: 'arrival_status_change',
        };
      }
      this.transferService.updateBooking(payload).then(
        (res: any) => {
          this.isLoading = false;
          this.messages.create('success', 'Status Changed to On Transfer');
          this.getPagedBookings();
          this.isVisibleFuelAndMileageUpdate = false;
          this.changingStatus = null;
          this.selectedReservation = null;
          this.fuelLevel = 0;
          this.mileage = 0;
        },
        (e: any) => {
          this.messages.create('error', 'Error');
        },
      );
    } else if (this.changingStatus === 'COMPLETED') {
      details.endFuel = this.fuelLevel;
      details.endMileage = this.mileage;
      details.status = 'COMPLETED';
      let payload = {};
      if (
        this.selectedReason === 'both' ||
        this.selectedReservation.bookingDetails.bookingCategory === 'Departure'
      ) {
        payload = {
          departureDetails: details,
          _id: this.selectedReservation._id,
          updateType: 'departure_status_change',
        };
      } else {
        payload = {
          arrivalDetails: details,
          _id: this.selectedReservation._id,
          updateType: 'arrival_status_change',
        };
      }
      this.transferService.updateBooking(payload).then(
        (res: any) => {
          this.isLoading = false;
          this.messages.create('success', 'Status Changed to Completed');
          this.getPagedBookings();
          this.isVisibleFuelAndMileageUpdate = false;
          this.changingStatus = null;
          this.selectedReservation = null;
          this.fuelLevel = 0;
          this.mileage = 0;
        },
        (e: any) => {
          this.messages.create('error', 'Error');
        },
      );
    }
  }

  addItem(input: HTMLInputElement): void {
    const value = input.value;
    if (this.cancelReasonOptions.indexOf(value) === -1) {
      this.cancelReasonOptions = [
        ...this.cancelReasonOptions,
        input.value || `New item ${this.index++}`,
      ];
    }
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }
  haveArrivalAndDeparture(data: any): boolean {
    return (
      data.bookingDetails.bookingCategory === 'Arrival' &&
      data.tourDetails.departureCheck &&
      (data.departureDetails?.status === this.statusFilter ||
        this.statusFilter === null)
    );
  }
  editBtnDisableCheck(data: any) {
    if (data.bookingDetails.bookingCategory === 'Departure') {
      return (
        data?.departureDetails.status === 'COMPLETED' ||
        data?.departureDetails.status === 'CANCELLED'
      );
    } else {
      return (
        data?.arrivalDetails.status === 'COMPLETED' ||
        data?.arrivalDetails.status === 'CANCELLED'
      );
    }
  }

  editBtnDisableCheckAdditional(data: any) {
    return (
      data?.departureDetails.status === 'COMPLETED' ||
      data?.departureDetails.status === 'CANCELLED'
    );
  }

  openMultiplePagingBoard() {
    this.openMultiplePagingBoardPopup = true;
  }
  onGetMultiplePagingBoardChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.openMultiplePagingBoardPopup = false;
        break;
    }
  }
}
